import classNames from "classnames";
import { t } from "i18next";
import { FunctionComponent, SVGProps } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as AndroidIcon } from "shared/assets/Icons/AndroidIcon.svg";
import { ReactComponent as InfoIcon } from "shared/assets/Icons/info-icon.svg";
import { ReactComponent as IosIcon } from "shared/assets/Icons/IosIcon.svg";
import { InformationModal } from "UIPalette/InformationModal/InformationModal";
import { trackBtnClicks } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

interface HealthSyncSectionProps {
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  heading: string;
  steps: string[];
}

const HealthSyncSection = ({ Icon, heading, steps }: HealthSyncSectionProps) => (
  <div className="text-left text-sm space-y-3">
    <div className="flex items-center gap-3">
      <Icon aria-hidden className="text-brand-purple w-7 h-7 shrink-0" />
      <h3 className="!pb-0">{heading}</h3>
    </div>
    <ul className="list-disc pl-5">
      {steps.map((step) => (
        <li key={step}>{step}</li>
      ))}
    </ul>
  </div>
);

interface HealthSyncInfoProps {
  modalId: string;
  className?: string;
}

export const HealthSyncInfo = ({ modalId, className }: HealthSyncInfoProps) => (
  <InformationModal
    modalId={modalId}
    title={t("wellbeing.healthSyncModal.title")}
    trigger={(show) => (
      <button
        type="button"
        aria-label={t("wellbeing.healthSyncModal.infoAriaLabel")}
        className={classNames("inline-block", className)}
        onClick={() => {
          trackBtnClicks(EventNames.TRACK_YOUR_WELLBEING_INFO_OPENED);
          show();
        }}
      >
        <InfoIcon className="text-brand-purple" />
      </button>
    )}
  >
    {(hide) => (
      <>
        <p className="!mt-1 text-sm">
          {t("wellbeing.healthSyncModal.description")}{" "}
          <Link to="/faqs" onClick={hide} className="font-bold underline">
            {t("wellbeing.faqs.heading")}
          </Link>
        </p>
        <HealthSyncSection
          Icon={IosIcon}
          heading={t("wellbeing.healthSyncModal.iphone.heading")}
          steps={[
            t("wellbeing.healthSyncModal.iphone.stepOne"),
            t("wellbeing.healthSyncModal.iphone.stepTwo"),
            t("wellbeing.healthSyncModal.iphone.stepThree"),
            t("wellbeing.healthSyncModal.iphone.stepFour"),
          ]}
        />
        <HealthSyncSection
          Icon={AndroidIcon}
          heading={t("wellbeing.healthSyncModal.android.heading")}
          steps={[
            t("wellbeing.healthSyncModal.android.stepOne"),
            t("wellbeing.healthSyncModal.android.stepTwo"),
            t("wellbeing.healthSyncModal.android.stepThree"),
          ]}
        />
      </>
    )}
  </InformationModal>
);
